export const FETCH_STATUS = Object.freeze({
  FETCHING: 'FETCHING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
});
